import * as festivals from './festivals';

const apis = {
  festivals
};

export default apis
